/* tslint:disable */
/* eslint-disable */
/**
 * Adgang API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type AuditEventResponse,
    AuditEventResponseFromJSON,
    AuditEventResponseToJSON,
} from '../models/AuditEventResponse';
import {
    type AuditEventResponsePagedResult,
    AuditEventResponsePagedResultFromJSON,
    AuditEventResponsePagedResultToJSON,
} from '../models/AuditEventResponsePagedResult';
import {
    type AuditEventSearchOrderBy,
    AuditEventSearchOrderByFromJSON,
    AuditEventSearchOrderByToJSON,
} from '../models/AuditEventSearchOrderBy';
import {
    type AuditEventSource,
    AuditEventSourceFromJSON,
    AuditEventSourceToJSON,
} from '../models/AuditEventSource';
import {
    type AuditEventSummaryResponse,
    AuditEventSummaryResponseFromJSON,
    AuditEventSummaryResponseToJSON,
} from '../models/AuditEventSummaryResponse';
import {
    type SortOrder,
    SortOrderFromJSON,
    SortOrderToJSON,
} from '../models/SortOrder';

export interface ApiAuditEventsGetRequest {
    pageNumber?: any;
    pageSize?: any;
    sortOrder?: SortOrder;
    orderField?: AuditEventSearchOrderBy;
    source?: AuditEventSource;
    category?: string;
    activity?: string;
    initiatedByUpn?: string;
    targetUpn?: string;
    ipAddress?: string;
    result?: string;
    fromUtc?: Date;
    toUtc?: Date;
}

export interface ApiAuditEventsIdGetRequest {
    id: number;
}

export interface ApiAuditEventsSummaryGetRequest {
    source?: AuditEventSource;
    category?: string;
    activity?: string;
    initiatedByUpn?: string;
    targetUpn?: string;
    ipAddress?: string;
    result?: string;
    fromUtc?: Date;
    toUtc?: Date;
}

/**
 * 
 */
export class AuditEventsApi extends runtime.BaseAPI {

    /**
     * Creates request options for apiAuditEventsGet without sending the request
     */
    async apiAuditEventsGetRequestOpts(requestParameters: ApiAuditEventsGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['pageNumber'] != null) {
            queryParameters['PageNumber'] = requestParameters['pageNumber'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['PageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortOrder'] != null) {
            queryParameters['SortOrder'] = requestParameters['sortOrder'];
        }

        if (requestParameters['orderField'] != null) {
            queryParameters['OrderField'] = requestParameters['orderField'];
        }

        if (requestParameters['source'] != null) {
            queryParameters['Source'] = requestParameters['source'];
        }

        if (requestParameters['category'] != null) {
            queryParameters['Category'] = requestParameters['category'];
        }

        if (requestParameters['activity'] != null) {
            queryParameters['Activity'] = requestParameters['activity'];
        }

        if (requestParameters['initiatedByUpn'] != null) {
            queryParameters['InitiatedByUpn'] = requestParameters['initiatedByUpn'];
        }

        if (requestParameters['targetUpn'] != null) {
            queryParameters['TargetUpn'] = requestParameters['targetUpn'];
        }

        if (requestParameters['ipAddress'] != null) {
            queryParameters['IpAddress'] = requestParameters['ipAddress'];
        }

        if (requestParameters['result'] != null) {
            queryParameters['Result'] = requestParameters['result'];
        }

        if (requestParameters['fromUtc'] != null) {
            queryParameters['FromUtc'] = (requestParameters['fromUtc'] as any).toISOString();
        }

        if (requestParameters['toUtc'] != null) {
            queryParameters['ToUtc'] = (requestParameters['toUtc'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/audit-events`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiAuditEventsGetRaw(requestParameters: ApiAuditEventsGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditEventResponsePagedResult>> {
        const requestOptions = await this.apiAuditEventsGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuditEventResponsePagedResultFromJSON(jsonValue));
    }

    /**
     */
    async apiAuditEventsGet(requestParameters: ApiAuditEventsGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditEventResponsePagedResult> {
        const response = await this.apiAuditEventsGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiAuditEventsIdGet without sending the request
     */
    async apiAuditEventsIdGetRequestOpts(requestParameters: ApiAuditEventsIdGetRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling apiAuditEventsIdGet().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/audit-events/{id}`;
        urlPath = urlPath.replace('{id}', encodeURIComponent(String(requestParameters['id'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiAuditEventsIdGetRaw(requestParameters: ApiAuditEventsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditEventResponse>> {
        const requestOptions = await this.apiAuditEventsIdGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuditEventResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiAuditEventsIdGet(requestParameters: ApiAuditEventsIdGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditEventResponse> {
        const response = await this.apiAuditEventsIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for apiAuditEventsSummaryGet without sending the request
     */
    async apiAuditEventsSummaryGetRequestOpts(requestParameters: ApiAuditEventsSummaryGetRequest): Promise<runtime.RequestOpts> {
        const queryParameters: any = {};

        if (requestParameters['source'] != null) {
            queryParameters['Source'] = requestParameters['source'];
        }

        if (requestParameters['category'] != null) {
            queryParameters['Category'] = requestParameters['category'];
        }

        if (requestParameters['activity'] != null) {
            queryParameters['Activity'] = requestParameters['activity'];
        }

        if (requestParameters['initiatedByUpn'] != null) {
            queryParameters['InitiatedByUpn'] = requestParameters['initiatedByUpn'];
        }

        if (requestParameters['targetUpn'] != null) {
            queryParameters['TargetUpn'] = requestParameters['targetUpn'];
        }

        if (requestParameters['ipAddress'] != null) {
            queryParameters['IpAddress'] = requestParameters['ipAddress'];
        }

        if (requestParameters['result'] != null) {
            queryParameters['Result'] = requestParameters['result'];
        }

        if (requestParameters['fromUtc'] != null) {
            queryParameters['FromUtc'] = (requestParameters['fromUtc'] as any).toISOString();
        }

        if (requestParameters['toUtc'] != null) {
            queryParameters['ToUtc'] = (requestParameters['toUtc'] as any).toISOString();
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/api/audit-events/summary`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     */
    async apiAuditEventsSummaryGetRaw(requestParameters: ApiAuditEventsSummaryGetRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AuditEventSummaryResponse>> {
        const requestOptions = await this.apiAuditEventsSummaryGetRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AuditEventSummaryResponseFromJSON(jsonValue));
    }

    /**
     */
    async apiAuditEventsSummaryGet(requestParameters: ApiAuditEventsSummaryGetRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AuditEventSummaryResponse> {
        const response = await this.apiAuditEventsSummaryGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
